import React from "react";
import Header from "./Header";
import p from "./img/profile.jpg";
import vector1 from "./img/vector2.svg";
import "./Home.css";
import { VscGithub, VscMail, VscCallIncoming } from "react-icons/vsc";
import { FaDev } from "react-icons/fa";
import About from "./About";

const Home = () => {
  return (
    <>
      <Header />
      <div className="main_home">
        <div className="profile">
          <div className="proimg">
            <img src={p} alt="profile" className="profile" width={250} />
          </div>
          <img src={vector1} alt="vector1" className="vector1" width={500} />
        </div>
        <div className="texts">
          <div className="p">
            <h3>Hy, My Name is </h3>
            <h1>Mishab K A</h1>
            <p>
              I am a full-stack web developer. my favorite programming language
              is JavaScript I am using the React.js JavaScript frameWork to
              develop applications.
            </p>

            {/* <textarea name="" id="" cols="30" rows="10"></textarea> */}
          </div>
          <div className="icons">
            <p>
              <VscGithub size={20} /> github.com/mishab-ka
            </p>
            <p>
              <FaDev size={20} />
              dev.to/mishabka
            </p>
            <p>
              <VscCallIncoming size={20} />
              +91 8590253089
            </p>
            <p>
              <VscMail size={20} />
              mishabrock@gmail.com
            </p>
          </div>
        </div>
      </div>
      <div className="projects">
        <h1>Projects</h1>
        <div className="btns">
          <a href="https://todoappy.netlify.app/">TodoApp</a>
          <a href="https://contactsv1.netlify.app/">Home Nursing </a>
          <a href="https://intouchhome.in">Contact Share</a>
        </div>
      </div>
      <About />
    </>
  );
};

export default Home;
